import { Box } from "theme-ui"
import "./style/style.css"
import { Button, Input } from "components"
import { useGreenWaveDisplayQuery } from "../../store/Features/processData/greenWaveDisplay-api-slice"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
interface ISetValues {
 server_id: number | undefined
 begin: string
 timespan: number
 green_band: boolean
}
interface IDevice {
 device_name: string
 server_id: number | undefined
}
export const GreenBelt = () => {
 // language translator
 const { t } = useTranslation("translation")
 const { data } = useGreenWaveDisplayQuery()
 const navigate = useNavigate()
 const [allDevices, setAllDevices] = useState<Array<IDevice>>([])
 const [values, setValues] = useState<ISetValues>({
  server_id: undefined,
  begin: "",
  timespan: 180,
  green_band: false,
 })
 const [serverIdError, setServerIdError] = useState<boolean>(false)

 useEffect(() => {
  if (data) {
   const extractedDevices: Array<{ device_name: string; server_id: number | undefined }> = []

   // Pushing a dummy object first
   extractedDevices.push({ device_name: "Select Device Name", server_id: undefined })
   data.forEach((entry) => {
    entry.forward_direction.forEach((device) => {
     extractedDevices.push({
      device_name: device.device_name,
      server_id: device.server_id !== null ? device.server_id : undefined,
     })
    })

    entry.reverse_direction.forEach((device) => {
     extractedDevices.push({
      device_name: device.device_name,
      server_id: device.server_id !== null ? device.server_id : undefined,
     })
    })
   })

   // Removing duplicates based on server_id
   const uniqueDevices = Array.from(
    new Map(extractedDevices.map((device) => [device.server_id, device])).values(),
   )

   setAllDevices(uniqueDevices)
  }
 }, [data]) // The empty dependency array ensures this effect runs once on mount

 const handleDate = () => {
  // Check if server_id is selected (assuming an empty string or null indicates not selected)
  if (!values.server_id) {
   // Set error message
   setServerIdError(true)
   // Prevent navigation if there's an error
   return
  }

  // Reset the error message in case it was set before
  setServerIdError(false)
  navigate(
   `/green-wave-display-graph?server_id=${values.server_id}${
    values.begin && "&begin=" + new Date(values.begin).toISOString()
   }${values.timespan && "&timespan=" + values.timespan}&green_band=${values.green_band}`,
  )
 }
 const handleValues = (value: any, name: string) => {
  setValues((prevOption) => ({
   ...prevOption,
   [name]: value,
  }))
 }

 return (
  <>
   <div className="w-[96%] mx-auto pt-6">
    <h1 className="font-semibold text-lg Jakarta-font ">{t("greenRepresentation")}</h1>
    <Box bg="highlight" color="text-black" className=" px-4 mt-2 py-4">
     <div className="flex justify-between items-center ">
      <h1 className="font-semibold text-lg Jakarta-font">{t("period")}</h1>
      <div className="Jakarta-font font-semi flex">
       <div className="mr-2">
        <Button size={"lg"} color={"white"}>
         Forum Gera
        </Button>
       </div>
       <div>
        <Button size={"lg"}>Test Server</Button>
       </div>
      </div>
     </div>
     <div className="flex justify-between mt-3">
      <div className="flex flex-col w-[35%] Jakarta-font ">
       <Input
        className="outline-none bg-gray py-3 rounded px-3 text-black"
        label={t("beginning")}
        type="datetime-local"
        id="begin"
        name="begin"
        value={values?.begin}
        onChange={(value, name) => {
         handleValues(value, name)
        }}
       />
      </div>

      <div className="w-[28%] Jakarta-font">
       <h1>{t("options")}:</h1>
       <div className="pt-2">
        <div className="custom-checkbox">
         <input
          type="checkbox"
          id="green_band"
          name="green_band"
          checked={values?.green_band}
          onChange={(e: any) => {
           handleValues(e.target.checked, e.target.name)
          }}
         />
         <label className="font-base Jakarta-font" htmlFor="green_band">
          Show only own green belts
         </label>
        </div>
       </div>
      </div>
     </div>
     <div className="flex gap-x-5 Jakarta-font mt-3">
      <div className="w-3/6">
       <Input
        label={t("PeriodTime")}
        className="bg-gray text-black pl-3 py-3 rounded outline-none w-full"
        type="number"
        name="timespan"
        value={`${values?.timespan}`}
        onChange={(value, name) => {
         handleValues(value, name)
        }}
       />
      </div>
      <div className="flex flex-col w-3/6">
       <label htmlFor="greenbelt-dropdown">{t("basicBand")}</label>
       <select
        id="greenbelt-dropdown"
        className="w-full bg-gray text-black pl-3 py-3 rounded outline-none"
        name="server_id"
        required
        value={values?.server_id as number}
        onChange={(e: any) => {
         handleValues(e.target.value, e.target.name)
        }}
       >
        {allDevices.map((option: IDevice, index: number) => (
         <option key={index} value={option.server_id || ""}>
          {option.device_name}
         </option>
        ))}
       </select>
       {serverIdError && <span style={{ color: "red" }}>Please select a device name.</span>}
      </div>
     </div>
     <div className="Jakarta-font flex justify-between items-center mt-4">
      <h1 className="text-xs">
       Some other information about these fields to clear the user to fill them*
      </h1>
      <div>
       <Button size={"doublexl"} onClick={handleDate}>
        {t("advert")}
       </Button>
      </div>
     </div>
    </Box>
   </div>
  </>
 )
}
